export enum EDrugManufacturerTypeId {
    offline = 1,
    online = 2,
    vendor = 3
}

export enum EErrorDrugManufacturerTypeId {
    invalid_format = 1,
    credential_error = 2
}